import PermissionType from '../../types/PermissionType';

const hasPermissions = (
    type: string,
    operation: string,
    permissions: { tag: string; operation: string }[],
    store?: string
) => {
    if (store) {
        return permissions.some(
            p =>
                (p.tag === `all-all-${type}` || p.tag === `all-${store}-${type}`) &&
                p.operation === operation
        );
    }

    return permissions.some(p => p.tag === `all-all-${type}` && p.operation === operation);
};

const hasWritePermissionsThatContains = (
    type: string,
    permissions: { tag: string; operation: string }[]
) => {
    return permissions.some(p => p.tag.includes(type) && p.operation === 'write');
};

const hasPermissionForTagsAndStore = (type: string, tags: string[], store: string) => {
    return tags.some(t => t === `all-${store}-${type}`);
};

const hasWriteCheckoutDetails = (
    store: string,
    permissions: { tag: string; operation: string }[]
) => hasPermissions(PermissionType.checkoutDetails, 'write', permissions, store);

const hasWriteCreditAccount = (permissions: { tag: string; operation: string }[]) =>
    hasWritePermissionsThatContains(PermissionType.creditAccount, permissions);

const hasReadCustomerDetails = (store: string, permissions: { tag: string; operation: string }[]) =>
    hasPermissions(PermissionType.customerDetails, 'read', permissions, store);

const hasWriteCreditAccountForStore = (
    store: string,
    permissions: { tag: string; operation: string }[]
) => hasPermissions(PermissionType.creditAccount, 'write', permissions, store);

export {
    hasWriteCheckoutDetails,
    hasWriteCreditAccountForStore,
    hasWriteCreditAccount,
    hasPermissionForTagsAndStore,
    hasReadCustomerDetails,
    hasPermissions,
};
